import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDevicePlatform, openStoreLinkByDevice } from "../utils/storeRedirect";
import {
  REQUIREMENT_SOURCE,
  trackPostRequirementSuccess,
} from "../utils/analytics";
import "../revamp/requirements/requirements.css";

const WEB_APP_URL = "https://hynt.co.in/app";

function SucessScreen({ onPostAnother }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isIos = getDevicePlatform() === "ios";

  useEffect(() => {
    trackPostRequirementSuccess({
      buttonName: "Post the requirement",
      source: location.state?.requirementSource || REQUIREMENT_SOURCE.WEBSITE,
      category: location.state?.category || "",
      categoryParam: location.state?.categoryParam || "",
    });
  }, [
    location.state?.category,
    location.state?.categoryParam,
    location.state?.requirementSource,
  ]);

  useEffect(() => {
    window.history.pushState({ requirementSuccess: true }, "", window.location.href);

    const handlePopState = () => {
      navigate("/", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [navigate]);

  const handleGetApp = () => {
    openStoreLinkByDevice();
  };

  return (
    <div className="requirements-page">
      <div className="requirements-shell">
        <div className="req-screen req-success-screen">
          <header className="req-success-header">
            <button
              type="button"
              className="req-success-back-btn"
              onClick={() => navigate("/", { replace: true })}
            >
              <img src="/caretLeft.svg" alt="" />
              <span>Back to home</span>
            </button>
          </header>

          <div className="req-content req-success-content">
            <div className="req-success-badge" aria-hidden="true">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>

            <p className="req-success-kicker">REQUIREMENT PUBLISHED</p>

            <h1 className="req-success-title">
              Your requirement is live —
              <br />
              manage it in the HYNT app
            </h1>

            <p className="req-success-desc">
              Your requirement is live on HYNT. Interested professionals will get
              in touch with you.
            </p>

            <div className="req-success-card">
              <div className="req-success-card-item">
                <span className="req-success-card-item-check" aria-hidden="true">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>
                <span className="req-success-card-item-text">
                  Track your requirement and edit or close it anytime
                </span>
              </div>

              <div className="req-success-card-item">
                <span className="req-success-card-item-check" aria-hidden="true">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>
                <span className="req-success-card-item-text">
                  Check verified profiles &amp; past work before you talk
                </span>
              </div>

              <div className="req-success-card-item">
                <span className="req-success-card-item-check" aria-hidden="true">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>
                <span className="req-success-card-item-text">
                  Explore more professionals on App
                </span>
              </div>
            </div>

            <div className="req-success-footer-actions">
              <button
                type="button"
                className="req-success-get-app-btn"
                onClick={handleGetApp}
              >
                Get the HYNT app · Free
              </button>

              <p className="req-success-store-info">
                Opens {isIos ? "App Store" : "Google Play"} · you&apos;ll be signed in automatically
              </p>

              <a
                href={WEB_APP_URL}
                className="req-success-continue-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Continue on website
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SucessScreen;
